import {
  AREAS_LOADING,
  SUBMIT_AREAS_ACTION_DISPATCHER,
  SUBMIT_AREAS_ACTION_REQUESTED,
  SUBMIT_AREAS_ERROR_DISPATCHER,
} from "./Action";

const initialState = {
  successData: { areaList: [], apiData: {} },
  failureData: {},
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_AREAS_ACTION_REQUESTED:
      return { ...state, loading: true };
    case SUBMIT_AREAS_ACTION_DISPATCHER:
      const areaList = []
      action.payload.data.success?.areas?.forEach((e) => {
        areaList.push({ value: e.area });
      });
      return {
        ...state,
        successData: {
          areaList: areaList.filter((v, i, a) => a.indexOf(v) === i),
          apiData: action.payload.data
        },
        loading: false,
      };
    case SUBMIT_AREAS_ERROR_DISPATCHER:
      return {
        ...state,
        failureData: action.payload,
        loading: false,
      };
    case AREAS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
